import request from '@/utils/request';
import { apiBase } from '@/utils/config';

// 转型项目融资首页滚动数据
export function getTransformationFinancingList() {
  return request({
    url: '/project/home/page/dynamic',
    method: 'GET',
  });
}
// 文件上传返回URL
export function uploadFileUrl() {
  return `${apiBase}/common/addfileurl`;
}

// 转型项目融资-申请
export function addApply(data) {
  return request({
    url: '/transformation/project/add',
    method: 'POST',
    data,
  });
}

// 融资需求类型
export function getFinancingTypeSel() {
  return request({
    url: '/transformation/project/init/financing/list',
    method: 'GET',
  });
}

// 所属行业
export function getIndustrySel() {
  return request({
    url: '/transformation/project/init/industry/list',
    method: 'GET',
  });
}

// 申请详情
export function getTransformationApplyDetail(id) {
  return request({
    url: '/transformation/project/detail',
    method: 'GET',
    params: { id },
  });
}

// 最新申请动态
export function getTransformationApplyTop10() {
  return request({
    url: '/transformation/project/applay/list',
    method: 'GET',
  });
}
